module.exports = __webpack_public_path__ + "static/media/bed-empty.0470cbbd.svg";